/* OOTB Code
We have overridden this file to trigger an event after show more ajax success to re-init lazy load and animate up */

'use strict';

const baseSearch = require('base/search/search');
const { queryFirst, updateUrlQueryParam, addClass, removeClass, queryAll, scrollTo, hasClass, renderFragment, getCookieMap, debounce, throttle, matchesBreakpoint } = require('../domUtil');
const { appendToUrl, formatMessage, getJSON, getNestedValue, isMobile } = require('../util');
const { emptySwatchTemplate } = require('../templates');
const { HIDDEN_CLASS, INVISIBLE_CLASS, REFINEMENT_TYPE_CATEGORY, SELECTED_CLASS, EVENT_KEY_ESC, EVENT_KEY_ENTER, EVENT_KEY_SPACE } = require('../constants');
const { enableAddAllToToteButton } = require('../product/helper');
const { refreshProductGridMarketingSlots, refreshIfLayoutChanged, clearProductGridInitialized } = require('./productGridSlotOrder');
const { toggleSelectSizeInfo } = require('../product/helper');
const { syncCollapsedFiltersA11y } = require('../helpers/searchHelper');
const $window = $(window);
const $body = $('body');
const $container = $('.container');
const $searchResultsContainer = $('.search-results.container');
const $filtersBarContainer = $('.search-results-container');
const $refinementBar = $('.refinement-bar');
const $modalBG = $('.modal-background');
const REFINEMENTS_CONTAINER_SELECTOR = '.refinements-container';
const { lp_hsc_enabled: akamaiEnabled, lp_hsc_category: plpCaching, lp_cache_hash: lpCacheHash, lp_group_hash: lpGroupHash } = getCookieMap();
const isAkamaiEnabled = akamaiEnabled === 'true' && plpCaching && lpCacheHash && lpGroupHash;
const akamaiSettings = (queryFirst('#akamai-settings') || { dataset: {} }).dataset;
const hideBtnMobile = queryFirst('.hide-mobile-filter-btn');
const hideClass = 'hidden-filters';
const showMoreRefinementClass = '.show-more-refinement';
const plpFiltersBar = queryAll('.js-plp-filters');
let cacheSyncTimer;
const observedTargets = new Set();
let tileToScroll;
let preventObserver = false;
const { SELECTOR_PRODUCT_GRID } = require('../productTiles/productTileConstants');

/**
 * Function that updates action url after every ajax call
 * @param {string} actionUrl action url
 */
function updateRefinementsAjaxUrl(actionUrl) {
    const refinementsContainer = queryFirst(REFINEMENTS_CONTAINER_SELECTOR);
    if (!refinementsContainer) return;

    refinementsContainer.dataset.actionUrl = actionUrl;
}

/**
 * Append Store filter params to action Url
 * @param {HTMLElement} element the element which triggered the filter
 * @param {string} actionUrl action url
 * @returns {string} updated action url
 */
function appendStoreFilterQueryParams(element, actionUrl) {
    // If event is triggered on storeToggle Checkbox, then proceed with url updation
    let storeToggleEl = element;
    if (element?.dataset?.refinementType === REFINEMENT_TYPE_CATEGORY) {
        // If event is triggered on refinement category, then find the storeToggle checkbox
        storeToggleEl = queryAll('.store-filter-toggle').find(toggle => toggle.checked) || queryFirst('.store-filter-toggle');
    }
    if (hasClass(storeToggleEl, 'store-filter-toggle')) {
        const STORE_ID_PARAM = 'storeID';
        const { storeId } = storeToggleEl.dataset;

        // Updating relative URL query params using URL api
        const url = new URL(location.origin + actionUrl);
        const { searchParams } = url;
        if (storeToggleEl.checked) {
            searchParams.set(STORE_ID_PARAM, storeId);
        } else {
            searchParams.delete(STORE_ID_PARAM);
        }
        url.search = searchParams.toString();

        // url.pathname -> "/on/demandware.store/Sites-lillypulitzer-sfra-Site/default/Search-ShowAjax"
        // url.search -> "?cgid=dresses-1-all&prefn1=refinementCategoryDresses&prefv1=Shift%7cA-Line%2fEasy%7cStraight"
        return url.pathname + url.search;
    }
    return actionUrl;
}

/**
 * Keeps the visible store-pickup control (role="checkbox" button) in sync with the hidden input.
 * @param {HTMLInputElement} checkbox - .store-filter-toggle
 */
function syncStorePickupFilterButtonFromCheckbox(checkbox) {
    if (!checkbox || !hasClass(checkbox, 'store-filter-toggle')) {
        return;
    }
    const row = checkbox.closest('.store-filter');
    if (!row) {
        return;
    }
    queryAll('.js-store-filter-focus-btn', row).forEach(focusBtn => {
        focusBtn.setAttribute('aria-checked', checkbox.checked ? 'true' : 'false');
        if (checkbox.checked) {
            addClass(focusBtn, SELECTED_CLASS);
        } else {
            removeClass(focusBtn, SELECTED_CLASS);
        }
    });
}

/**
 * Sync every store pickup checkbox (and its focus button) to match the source toggle.
 * @param {HTMLInputElement} sourceCheckbox - checkbox that triggered the change
 */
function syncAllStorePickupFilterToggles(sourceCheckbox) {
    if (!sourceCheckbox || !hasClass(sourceCheckbox, 'store-filter-toggle')) {
        return;
    }

    const { checked, dataset } = sourceCheckbox;
    const { storeId, storeName } = dataset;

    queryAll('.store-filter-toggle').forEach(toggle => {
        if (toggle !== sourceCheckbox) {
            toggle.checked = checked;
            if (storeId) {
                toggle.dataset.storeId = storeId;
            } else {
                delete toggle.dataset.storeId;
            }
            if (storeName) {
                toggle.dataset.storeName = storeName;
            } else {
                delete toggle.dataset.storeName;
            }
        }
        syncStorePickupFilterButtonFromCheckbox(toggle);
    });
}

/**
 * Update all store selector buttons except the no-results link.
 * @param {string} storeName - store display name
 * @param {string} fullLabel - full sidebar label including city and state
 */
function updateStorePickupSelectorButtons(storeName, fullLabel) {
    queryAll('.btn-in-store-pickup').forEach(storeSelectorEl => {
        if (storeSelectorEl.closest('.no-filter-results')) {
            return;
        }

        const storeNameEl = queryFirst('.store-filter-store-name', storeSelectorEl);
        const ispuLabel = storeSelectorEl.dataset.ispuLabel || '';

        if (storeNameEl) {
            storeNameEl.textContent = fullLabel || storeName || '';
        } else {
            const label = fullLabel || storeName || '';
            storeSelectorEl.textContent = '';
            if (label) {
                storeSelectorEl.appendChild(document.createTextNode(label));
            }
            const chevron = document.createElement('i');
            chevron.className = 'lp-icon-chevron chevron-right';
            chevron.setAttribute('aria-hidden', 'true');
            storeSelectorEl.appendChild(chevron);
        }

        const storeDisplay = fullLabel || storeName || '';
        const withStoreLabelPattern = storeSelectorEl.dataset.ispuWithStoreLabel;

        if (storeDisplay && withStoreLabelPattern) {
            storeSelectorEl.setAttribute('aria-label', withStoreLabelPattern.replace('__STORE__', storeDisplay));
        } else {
            storeSelectorEl.setAttribute('aria-label', ispuLabel);
        }
    });
}

/**
 * Keep inline/header store pickup controls aligned with the sidebar after Ajax updates.
 */
function syncStorePickupFiltersAfterAjax() {
    const sourceToggle = queryFirst('.store-filter-container .store-filter-toggle');
    if (!sourceToggle) {
        return;
    }

    syncAllStorePickupFilterToggles(sourceToggle);

    const sourceStoreBtn = queryFirst('.store-filter-container .btn-in-store-pickup');
    const storeName = sourceToggle.dataset.storeName || '';
    const fullLabel = sourceStoreBtn
        ? Array.from(sourceStoreBtn.childNodes)
            .filter(node => node.nodeType === Node.TEXT_NODE)
            .map(node => node.textContent.trim())
            .filter(Boolean)
            .join(' ')
        : '';

    updateStorePickupSelectorButtons(storeName, fullLabel);
}

/**
 * Toggle the hidden store filter checkbox from its visible focus button.
 * @param {HTMLElement} focusBtn - .js-store-filter-focus-btn
 */
function toggleStoreFilterFromFocusBtn(focusBtn) {
    const storeFilterRow = focusBtn.closest('.store-filter');
    const storeCheckbox = storeFilterRow && queryFirst('.store-filter-toggle', storeFilterRow);

    if (storeCheckbox) {
        storeCheckbox.click();
    }
}

/**
 * Keep role="checkbox" color refinements consistent: aria-checked follows the .selected class (source of truth for visuals).
 * @param {ParentNode} [root] optional scope; defaults to document
 */
function syncColorRefinementCheckboxControls(root) {
    const scope = root?.querySelectorAll ? root : document;
    queryAll('.color-refinements-btn[role="checkbox"]', scope).forEach(el => {
        el.setAttribute('aria-checked', hasClass(el, SELECTED_CLASS) ? 'true' : 'false');
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {string} - Selected sort.
 */
function updateSortOptions(fragment) {
    const toggleEls = queryAll('.sort-order-menu-toggle span');
    const gridFooter = queryFirst('.grid-footer', fragment);

    if (gridFooter && toggleEls.length) {
        const dataSortLabel = gridFooter.dataset.sortLabel;
        toggleEls.forEach(toggleEl => {
            toggleEl.textContent = dataSortLabel;
        });

        const { options: sortOptions, ruleId: selectedRule } = JSON.parse(gridFooter.dataset.sortOptions);

        sortOptions.forEach(function (option) {
            const $sortOption = $('.sort-order-menu-dropdown button[data-id="' + option.id + '"], button[data-id="' + option.id + '"].sort-order-menu-option');
            $sortOption.val(option.url);
            if (option.ruleId === selectedRule) {
                $sortOption.addClass('selected');
                $sortOption.attr('aria-selected', 'true');
                toggleEls.forEach(toggleEl => {
                    toggleEl.textContent = option.displayName;
                });
            } else {
                $sortOption.removeClass('selected');
                $sortOption.attr('aria-selected', 'false');
            }
        });
    }
    return toggleEls && toggleEls[0] ? toggleEls[0].textContent : '';
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom(fragment, selector) {
    const containers = queryAll(selector);
    const updates = queryFirst(selector, fragment);

    if (containers.length && updates) {
        containers.forEach(container => {
            const clone = updates.cloneNode(true);

            container.parentElement.replaceChild(clone, container);
        });
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {undefined}
 */
function handleRefinements(fragment) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = queryFirst('.' + $(this)[0].className.replace(/ /g, '.'), fragment);
        addClass(activeDiv, 'active');
        queryFirst('button.title', activeDiv).setAttribute('aria-expanded', 'true');
    });
    // show category in filter bar only in case if cgid!=selected refinement ID
    if (queryFirst('.category-id', fragment)?.value !== queryFirst('.js-parent-category')?.dataset.refinementId) {
        removeClass(queryFirst('.js-category-refinement', fragment), HIDDEN_CLASS);
    }

    queryAll(showMoreRefinementClass, fragment)?.forEach(element => {
        if (!queryFirst(`li.${HIDDEN_CLASS}`, element.parentElement)) {
            addClass(element, HIDDEN_CLASS);
        }
    });

    scrollTo(0, 0);
    updateDom(fragment, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 */
function parseResults(fragment) {
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    ['.grid-header', '.header-bar', '.header.page-title', '.product-grid', '.show-more', '.filter-bar', '.store-filter-container', '.js-productsearch-footer'].forEach(function (selector) {
        updateDom(fragment, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector](fragment);
    });

    syncColorRefinementCheckboxControls();
    syncStorePickupFiltersAfterAjax();
}

/**
 * Update Category refinement
 * @param {Element} element selected element
 */
function updateCategoryRefinemnts(element) {
    if (!element) return;
    const bar = element.closest('.subcategory-refinement-bar');
    if (!bar) {
        return;
    }
    // Only horizontal category tabs (see categories.isml). Avoid clearing every .selected under the bar — that can
    // desync ARIA from unrelated descendants and is broader than needed.
    queryAll('[data-refinement-type="category"]', bar).forEach(btn => {
        removeClass(btn, SELECTED_CLASS);
        btn.setAttribute('aria-selected', 'false');
    });
    addClass(element, SELECTED_CLASS);
    element.setAttribute('aria-selected', 'true');
}

/**
 * Update search results count
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {number} Returns the total number of search results
 */
function updateCount(fragment) {
    const productCount = queryFirst('.current-product-count', fragment);
    const resultCounts = queryAll('.result-count');

    if (!productCount) {
        const noFilterResults = queryFirst('.no-filter-results', fragment);

        if (noFilterResults) {
            resultCounts.forEach(item => {
                item.textContent = noFilterResults.dataset.noproductcount;
            });
        }
    } else {
        resultCounts.forEach(item => {
            item.textContent = productCount.value;
        });
        const productCountTextFragment = queryFirst('.result-text', fragment);
        if (productCountTextFragment) {
            queryAll('.result-text').forEach(item => {
                const clone = productCountTextFragment.cloneNode(true);
                item.textContent = clone.innerHTML;
            });
        }
    }

    const container = queryFirst('.no-filter-results');
    const resultCountsText = getNestedValue(resultCounts, '[0].innerText');

    if (container) {
        const resultCountsDigits = resultCountsText && resultCountsText.replace(/\D/g, '');
        const numOfProducts = parseInt(resultCountsDigits, 10);

        if (numOfProducts > 0) {
            addClass(container, HIDDEN_CLASS);
        } else {
            removeClass(container, HIDDEN_CLASS);
        }
    }

    return parseInt(((resultCountsText && resultCountsText.split(' of ')[1]) || '0').replace(/\D/g, ''), 10);
}

/**
 * remove hidden class 'd-none' for selected filter count
 */
function removeHiddenClassForSelectedCount() {
    const hiddenFilterCountElements = queryAll('.selected-filter-count.' + HIDDEN_CLASS);
    if (hiddenFilterCountElements) removeClass(hiddenFilterCountElements, HIDDEN_CLASS);
}

/**
 * determines if storePickUp filter is checked
 * @returns {boolean} checked/unchecked
 */
function isStorePickUpChecked() {
    return queryAll('.store-filter-toggle').some(toggle => toggle.checked);
}

/**
 * add store pickup filter to the filter counter
 */
function addStorePickUpToFilterCounter() {
    if (!isStorePickUpChecked()) return;

    const searchResultContainer = queryFirst('.search-results.container');
    const selectedFilterCounts = queryAll('.js-selected-filter-count', searchResultContainer);
    selectedFilterCounts.forEach(selectedFilterCount => {
        if (selectedFilterCount && selectedFilterCount.innerText) {
            selectedFilterCount.innerText = parseInt(selectedFilterCount.innerText, 10) + 1;
        }
    });
    removeHiddenClassForSelectedCount();

    // add store pickUp to the 'filter counter' for the extra 'filter counter field' on mobile
    const filterCountMobile = isMobile() && queryFirst('.js-filter-count-mobile', searchResultContainer);
    if (filterCountMobile && filterCountMobile.innerText) {
        filterCountMobile.innerText = parseInt(filterCountMobile.innerText, 10) + 1;
    }
}

/**
 * Update filter count
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {undefined}
 */
function updateFilterCount(fragment) {
    const filterCountWrapper = queryFirst('.selected-filter-count', fragment);
    const filterCount = queryFirst('.js-selected-filter-count', fragment);
    const productCount = queryFirst('.no-filter-results', fragment);
    const resetFilterBtnFragment = queryFirst('.js-clear-filters-btn', fragment);
    const resetFilterBtns = queryAll('.js-clear-filters-btn');
    const searchResultContainer = queryFirst('.search-results.container');
    const selectedFilterCounts = queryAll('.js-selected-filter-count', searchResultContainer);
    const showFilterSortHeader = queryFirst('.show-filter-sort-header', searchResultContainer);
    const displayClass = 'd-md-flex';

    if (filterCountWrapper) {
        if (!selectedFilterCounts.length) {
            queryAll('.js-filter-text', searchResultContainer).forEach(filterText => {
                // Clone the filterCountWrapper element to ensure a new one is inserted each time
                const clone = filterCountWrapper.cloneNode(true);
                if (filterText.nextSibling) {
                    filterText.parentNode.insertBefore(clone, filterText.nextSibling);
                } else {
                    filterText.parentNode.appendChild(clone);
                }
            });
        } else {
            selectedFilterCounts.forEach(selectedFilterCount => {
                const clone = filterCount.cloneNode(true);
                selectedFilterCount.replaceWith(clone);
            });
        }
    } else {
        selectedFilterCounts.forEach(selectedFilterCount => {
            selectedFilterCount.closest('.selected-filter-count').remove();
        });
    }

    queryAll('.js-hide-filter', searchResultContainer).forEach(filterBtn => {
        if (resetFilterBtnFragment && !resetFilterBtns.length) {
            const clone = resetFilterBtnFragment.cloneNode(true);
            if (filterBtn.nextSibling) {
                filterBtn.parentNode.insertBefore(clone, filterBtn.nextSibling);
            } else {
                filterBtn.parentNode.appendChild(clone);
            }
        } else if (resetFilterBtns.length && !resetFilterBtnFragment) {
            resetFilterBtns.forEach(resetFilterBtn => {
                resetFilterBtn.remove();
            });
        }
    });

    // This will show/hide desktop filter and sorting fillter in desktop if product count is zero
    if (!productCount || productCount.dataset.productcount !== '0') {
        addClass(showFilterSortHeader, displayClass);
    } else {
        removeClass(showFilterSortHeader, displayClass);
    }

    addStorePickUpToFilterCounter();
}

/**
 * Update show no results message
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {undefined}
 */
function showNoResultsText(fragment) {
    const noFilterResults = queryFirst('.no-filter-results', fragment);
    if (noFilterResults) {
        const numOfProducts = parseInt(noFilterResults.dataset.productcount, 10);

        if (numOfProducts > 0 && !noFilterResults.classList.contains(HIDDEN_CLASS)) {
            noFilterResults.classList.add(HIDDEN_CLASS);
        } else {
            noFilterResults.classList.remove(HIDDEN_CLASS);
        }

        const container = queryFirst('.no-filter-results');

        if (container) container.parentElement.replaceChild(noFilterResults, container);
    } else {
        console.error('Could not find element in filter results fragment'); // eslint-disable-line no-console
    }
}

/**
 * Update Page Title, Description and Canonical URL with color filter
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {undefined}
 */
const updatePageTitle = fragment => {
    const pageTitle = queryFirst('.seo-page-title', fragment);
    const pageDescription = queryFirst('.seo-page-description');
    const canonicalUrl = queryFirst('.canonical-url');

    if (pageTitle) document.title = pageTitle.value;

    if (pageDescription) {
        const metaTag = queryFirst('meta[name="description"]');

        if (metaTag) metaTag.setAttribute('content', pageDescription.value);
    }

    if (canonicalUrl) {
        const canonLink = queryFirst('link[rel="canonical"]');

        if (canonLink) canonLink.setAttribute('href', canonicalUrl.value);
    }
};

/**
 * Update plp filters swatch images
 *
 * @param {DocumentFragment} fragment - A DocumentFragment object
 * @return {undefined}
 */
function updatePatternImageSwatch(fragment) {
    const refinementPatterns = queryFirst('#refinement-print--pattern-and-solid', fragment);

    if (!refinementPatterns) return;

    const imgItems = queryAll('.refinement-image', refinementPatterns);

    imgItems.forEach(imageEl => {
        const { src, srcset } = imageEl.dataset;

        imageEl.src = src;

        if (srcset) imageEl.srcset = srcset;

        removeClass(imageEl, INVISIBLE_CLASS);
        imageEl.onload = () => addClass(imageEl, 'image-loaded');
    });

    const container = queryFirst('#refinement-print--pattern-and-solid');

    if (container) container.parentElement.replaceChild(refinementPatterns, container);
}

/**
 * Updates PLP products with out of stock text where applicable.
 * @param {Object} staleProductIds - A plain object of variation group IDs / inStock status
 */
function updateProducts(staleProductIds) {
    if (!staleProductIds || Object.keys(staleProductIds).length === 0) return;

    const productGrid = queryFirst('.product-grid');
    const currentProductIds = queryAll('.product', productGrid)
        .map(node => node.dataset.pid)
        .filter(Boolean);

    if (currentProductIds.length === 0) return;

    const oosProducts = Object.keys(staleProductIds).filter(productId => !staleProductIds[productId]);
    const { outOfStockMessage = '' } = productGrid.dataset;
    const oosClass = 'out-of-stock';

    oosProducts.forEach(productId => {
        const node = queryFirst(`.product[data-pid="${productId}"]`, productGrid);
        if (!node || node.classList.contains(oosClass)) return;

        const numSwatches = queryAll('.color-swatches button', node).length;
        // If there are multiple swatches, we don't know whether those are OOS too.
        if (numSwatches > 1) return;

        node.classList.add(oosClass);

        // If there's just 1 swatch, mark it as Sold Out.
        const swatches = queryFirst('.color-swatches .swatches', node);
        if (swatches) swatches.innerHTML = formatMessage(emptySwatchTemplate, outOfStockMessage);
    });
}

/**
 * check if it is the last selected refinement in the group
 * and get current group id
 * @param {Object} element dom element
 *  @returns {string|boolean} current filter/refinement group id
 */
function getCurrentFilterGroup(element) {
    if (!hasClass(element, 'selected')) return false;

    const $jsRefinement = $(element).closest('.js-refinement');
    const isLastSelectedRefinement = $jsRefinement.find('.js-refinement-content li button.selected').length === 1;
    const isSizeRefinement = $jsRefinement.hasClass('js-size-refinements');

    // check if it is the last selected element
    // check if it is 'size' refinement, because there may be selected multiple sizes after one click
    return (isLastSelectedRefinement || isSizeRefinement) && $jsRefinement.data('filter-group-id');
}

/**
 * show refinements for the current group
 * if there is currentRefinementGroup obtained from getCurrentFilterGroup()
 * @param {string} currentRefinementGroup data-filter-group-id
 */
function showRefinementContent(currentRefinementGroup) {
    const jsRefinement = queryFirst('.js-refinement[data-filter-group-id="' + currentRefinementGroup + '"]');
    const jsRefinementContent = jsRefinement && queryFirst('.js-refinement-content', jsRefinement);

    if (jsRefinementContent && !hasClass(jsRefinementContent, 'show')) {
        addClass(jsRefinementContent, 'show');

        const jsShowFilterBtn = queryFirst('.js-show-filter-btn', jsRefinement);
        if (jsShowFilterBtn) {
            removeClass(jsShowFilterBtn, 'collapsed');
            jsShowFilterBtn.setAttribute('aria-expanded', 'true');
        }
    }
}

/**
 *
 * @param {Object} element dom element
 * @param {string} actionUrl action url
 */
function getResultsOnPriceFilter(element, actionUrl) {
    const prevActionUrl = actionUrl;
    const updatedActionUrl = appendStoreFilterQueryParams(element, actionUrl);
    const akamaiActionUrl = isAkamaiEnabled
        ? appendToUrl(updatedActionUrl, {
            'lp-cache-hash': lpCacheHash,
            'lp-group-hash': lpGroupHash
        })
        : updatedActionUrl;
    const gridFooter = queryFirst('.grid-footer');
    const pageNumber = (gridFooter && gridFooter.dataset.pageNumber) || 0;
    const currentRefinementGroup = getCurrentFilterGroup(element);
    const refinementType = element.dataset?.refinementType;

    clearProductGridInitialized();

    $.ajax({
        url: akamaiActionUrl,
        data: {
            page: pageNumber,
            selectedUrl: akamaiActionUrl
        },
        success: function (response, status, xhr) {
            const serverTiming = xhr.getResponseHeader('server-timing') || '';
            const isCached = !!(serverTiming && serverTiming.split('desc=')[1].split(',')[0] === 'HIT');

            if (hasClass(element, 'clear-filters-btn') && $('.no-filter-results').attr('data-productcount') === '0') {
                $('.store-filter-toggle').each(function () {
                    this.checked = false;
                    syncStorePickupFilterButtonFromCheckbox(this);
                });
            }
            updateRefinementsAjaxUrl(prevActionUrl);

            const fragment = renderFragment(response);

            updateUrlQueryParam(fragment);
            parseResults(fragment);
            updateSortOptions(fragment);
            updatePageTitle(fragment);
            showNoResultsText(fragment);
            if (refinementType === REFINEMENT_TYPE_CATEGORY) {
                updateCategoryRefinemnts(element);
            }

            const productCount = updateCount(fragment);

            updateFilterCount(fragment);
            updatePatternImageSwatch(fragment);

            const container = queryFirst('.no-filter-results');
            if (container) {
                if ($('.no-filter-results').attr('data-productcount') !== '0') {
                    addClass(container, HIDDEN_CLASS);
                } else {
                    removeClass(container, HIDDEN_CLASS);
                }
            }
            $body.trigger('search:updateProducts', element); // LP custom changes end

            // Check Akamai cache
            if (isCached) {
                const cacheKey = encodeURIComponent(xhr.getResponseHeader('x-cache-key'));
                const productIds = queryAll('.product-grid .product')
                    .map(node => `${node.dataset.pid}:${!queryFirst('.swatches-empty', node)}`)
                    .filter(Boolean)
                    .join(',');
                const syncUrl = akamaiActionUrl.replace('ShowAjax', 'SyncShowAjax');

                clearTimeout(cacheSyncTimer);

                cacheSyncTimer = setTimeout(() => {
                    getJSON(syncUrl, 'POST', { productCount, cacheKey, productIds }, data => {
                        if (data.stale) {
                            // Update products with fresh stock status if we can
                            updateProducts(data.staleProductIds);

                            if (data.cacheInvalidated) {
                                // Akamai takes about 5 seconds to clear an entry
                                // Once that's complete, we should rebuild the cache with a fresh request
                                setTimeout(() => {
                                    $.ajax({
                                        url: akamaiActionUrl,
                                        data: {
                                            page: pageNumber,
                                            selectedUrl: akamaiActionUrl
                                        }
                                    });
                                }, akamaiSettings.cacheRefreshDelay);
                            }
                        }
                    });
                }, akamaiSettings.cacheSyncDelay);
            }

            if (currentRefinementGroup) showRefinementContent(currentRefinementGroup);

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * return Akamai action url
 * @param {string} showMoreUrl link for products load
 * @returns {string} updated link
 */
function getAkamaiActionUrl(showMoreUrl) {
    return isAkamaiEnabled
        ? appendToUrl(showMoreUrl, {
            'lp-cache-hash': lpCacheHash,
            'lp-group-hash': lpGroupHash
        })
        : showMoreUrl;
}

/**
 *
 * @param {string} showMoreUrl URL used to fetch new products
 * @param {Object} e Event causing this update
 * @param {boolean} isPagination Boolean true if this is a pagination-based update; false if "Show More"
 * @param {boolean} isBackButton true if loading because of a back button click; false otherwise. Avoids pushing duplicate history entries.
 * @param {observerObj} observerObj Observe object
 * @param {boolean} isPrevious true in case of load produts from end to starts
 */
function loadProducts(showMoreUrl, e, isPagination, isBackButton = false, observerObj = {}, isPrevious = false) {
    $.spinner().start();
    if (!isPagination) {
        announceMessage(`Loading ${isPrevious ? 'previous' : 'next'} page…`);
    } else {
        announceMessage(`Loading page…`);
    }

    clearProductGridInitialized();
    $body.trigger('search:showMore', e);

    if (isPagination) {
        // scrolling to top before the new products are added to the page allows the lazy loader to be more effective
        const plpHeader = queryFirst('.clp-results-header');
        const mainHeader = queryFirst('.main-header');
        scrollTo(plpHeader && mainHeader ? plpHeader.offsetTop - mainHeader.offsetHeight : 0);
    }

    const akamaiActionUrl = getAkamaiActionUrl(showMoreUrl);
    $.ajax({
        url: akamaiActionUrl,
        data: { selectedUrl: akamaiActionUrl },
        success: (response, status, xhr) => {
            const headers = {
                serverTiming: xhr.getResponseHeader('server-timing') || '',
                xCacheKey: xhr.getResponseHeader('x-cache-key')
            };
            if (isPrevious) {
                const grid = queryFirst(SELECTOR_PRODUCT_GRID);
                if (!tileToScroll) {
                    tileToScroll = queryFirst('.product', grid);
                }
            }
            getProductsCallBack(headers, akamaiActionUrl, response, isPagination, isBackButton, isPrevious);

            scrollToTile();
            $.spinner().stop();
            preventObserver = false;
            if (!isPagination) {
                announceMessage(`Showing ${isPrevious ? 'previous' : 'next'} page of products.`);
            } else {
                 announceMessage('Page loaded');
            }
        },
        error: function () {
            $.spinner().stop();
            announceMessage('An error occured, could not load the page');
        }
    });
}

/**
 * Callback for updating PLP
 * @param {Object} headers response headers
 * @param {string} akamaiActionUrl akamai link
 * @param {Object} response Response object
 * @param {boolean} isPagination Boolean true if this is a pagination-based update; false if "Show More"
 * @param {boolean} isBackButton true if loading because of a back button click; false otherwise. Avoids pushing duplicate history entries.
 * @param {boolean} isPrevious true in case of load produts from end to starts
 */
function getProductsCallBack(headers, akamaiActionUrl, response, isPagination, isBackButton, isPrevious) {
    const isCached = !!(headers.serverTiming && headers.serverTiming.split('desc=')[1].split(',')[0] === 'HIT');

    if (isPagination) {
        $('.product-grid').html(response);
        refreshProductGridMarketingSlots(queryFirst(SELECTOR_PRODUCT_GRID));
    } else if (isPrevious) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(response, 'text/html');
        const footer = queryFirst('.grid-footer', doc);
        queryFirst('.js-show-previous').dataset.url = queryFirst('.js-show-previous', doc)?.dataset.url || '';
        if (footer) {
            footer.remove();
        }

        addClass(queryAll('.product-tile-container, .category-marketing-slot', doc), HIDDEN_CLASS);

        const targetDiv = queryFirst('.js-product-grid .product-tile-container');

        targetDiv.insertAdjacentHTML('beforebegin', doc.body.innerHTML);

        removeClass(queryAll('.product-tile-container, .category-marketing-slot'), HIDDEN_CLASS);
        updateSlotsMarkup();
        refreshProductGridMarketingSlots(queryFirst(SELECTOR_PRODUCT_GRID));
    } else {
        const prevElementLink = queryFirst('.js-show-previous')?.dataset.url || '';

        $('.grid-footer').replaceWith(response);

        const updatedPrevElement = queryFirst('.js-show-previous');
        if (updatedPrevElement) {
            updatedPrevElement.dataset.url = prevElementLink;
        }

        updateSlotsMarkup();
        refreshProductGridMarketingSlots(queryFirst(SELECTOR_PRODUCT_GRID));
    }

    const fragment = renderFragment(response);

    updateSortOptions(fragment);
    // LP custom changes start
    if (!isBackButton && !isPrevious) {
        // Pagination: don't update querystring on back button click -- otherwise user gets stuck after the fist time they click back due to a new history entry being pushed
        updateUrlQueryParam(fragment);
    }

    const productCount = updateCount(fragment);

    $body.trigger('search:updateProducts');

    // Check Akamai cache
    if (isCached) {
        const cacheKey = encodeURIComponent(headers.xCacheKey);
        const gridFooter = queryFirst('.grid-footer', fragment);
        const pageSize = (gridFooter && parseInt(gridFooter.dataset.pageSize, 10)) || 48;
        const productIds = queryAll('.product-grid .product')
            .slice(-pageSize)
            .map(node => `${node.dataset.pid}:${!queryFirst('.swatches-empty', node)}`)
            .filter(Boolean)
            .join(',');
        const syncUrl = akamaiActionUrl.replace('UpdateGrid', 'SyncUpdateGrid');

        clearTimeout(cacheSyncTimer);

        cacheSyncTimer = setTimeout(() => {
            getJSON(syncUrl, 'POST', { productCount, cacheKey, productIds }, data => {
                if (data.stale) {
                    // Update products with fresh stock status if we can
                    updateProducts(data.staleProductIds);

                    if (data.cacheInvalidated) {
                        // Once that's complete, we should rebuild the cache with a fresh request
                        setTimeout(() => {
                            $.ajax({
                                url: akamaiActionUrl,
                                data: {
                                    selectedUrl: akamaiActionUrl
                                }
                            });
                        }, akamaiSettings.cacheRefreshDelay);
                    }
                }
            });
        }, akamaiSettings.cacheSyncDelay);
    }
}

/**
 * Method to initialise the  intersection observer
 *
 */
baseSearch.initialiseSearchIntersection = () => {
    if (!queryFirst('.js-infinite-scroll-enabled')) {
        return;
    }
    const observerTargetNext = queryFirst('#footercontent');
    const observerTargetPrev = queryFirst('.page-title.plp-title');
    const deltaTop = observerTargetNext.getBoundingClientRect().top - queryFirst('.grid-footer').getBoundingClientRect().top + 100;

    const optionsNext = {
        rootMargin: `${Math.ceil(deltaTop)}px 0px`,
        threshold: 0.01
    };
    const optionsPrev = {
        rootMargin: '200px 0px',
        threshold: 0.01
    };

    /**
     * Represents a callback function which will be called when the observed target element enters the viewport
     * @param {Array} entries IntersectionObserverEntry Objects
     */
    function handleIntersect(entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                if (preventObserver) {
                    return false;
                }
                let targetURL = queryFirst('.show-more button')?.dataset.url;
                let isPrevious = false;
                if (entry.target === observerTargetPrev) {
                    targetURL = queryFirst('.js-show-previous')?.dataset.url;
                    isPrevious = true;
                }

                if (!targetURL) return;
                preventObserver = true;
                const infiniteScrollEvent = new Event('infiniteScrollEvent');
                const observerObj = {
                    target: entry.target
                };
                loadProducts(targetURL, infiniteScrollEvent, false, false, observerObj, isPrevious);
            }
        });
    }
    let observerNext = new IntersectionObserver(handleIntersect, optionsNext);
    let observerPrev = new IntersectionObserver(handleIntersect, optionsPrev);

    // Safely observe the initial targets
    if (observerTargetNext) {
        if (!observedTargets.has(observerTargetNext)) {
            observerNext.observe(observerTargetNext);
            observedTargets.add(observerTargetNext);
        }
    }
    if (observerTargetPrev) {
        if (!observedTargets.has(observerTargetPrev)) {
            observerPrev.observe(observerTargetPrev);
            observedTargets.add(observerTargetPrev);
        }
    }
}

/**
 * Function to apply store filter on PLP page
 * @param {HTMLElement} checkboxToggleEl Store filter toggle checkbox element
 * @param {boolean} appendStoreID Flag to append storeID to URL params
 */
function applyStoreFilter(checkboxToggleEl) {
    const refinementsContainer = queryFirst(REFINEMENTS_CONTAINER_SELECTOR);
    if (!refinementsContainer) return;

    const { actionUrl } = refinementsContainer.dataset;

    // Perform Filter
    $.spinner().start();
    getResultsOnPriceFilter(checkboxToggleEl, actionUrl);
}

/**
 * update 'productInfo' and 'productInventory' from quickviewProductInfo data
 * @param {Object} quickviewProductInfo productInfo data
 */
function updateProductInfoFromQuickViewInfo(quickviewProductInfo) {
    const { productInfo, productInventory } = quickviewProductInfo;
    if (!productInfo || !productInventory || !productInfo.length || !productInventory.length) return;

    if (!window.productInfo) window.productInfo = {};
    for (let i = 0, n = productInfo.length; i < n; i++) {
        let productData = productInfo[i];
        window.productInfo[productData.id] = productData.data;
    }

    if (!window.productInventory) window.productInventory = {};
    for (let i = 0, n = productInventory.length; i < n; i++) {
        let productInventoryData = productInventory[i];
        window.productInventory[productInventoryData.id] = productInventoryData.data;
    }
}

/**
 * Update The filter count if storefilter is applied on load
 */
$(function () {
    const noResultsRecommendationPage = queryFirst('.no-results-recommendations');
    const noFilterResults = queryFirst('.no-filter-results');
    const refinementPrice = queryFirst('.refinement-price');

    if (refinementPrice) {
        const minPrice = queryFirst('.price-filter-min', refinementPrice).value;
        const maxPrice = queryFirst('.price-filter-max', refinementPrice).value;

        if ((minPrice || maxPrice) && noResultsRecommendationPage) {
            addClass(noResultsRecommendationPage, HIDDEN_CLASS);
        }
    }

    addStorePickUpToFilterCounter();

    // On page reload or category change, if products are available
    // hide the clear filter (no results section)

    if (noFilterResults) {
        const numOfProducts = noFilterResults.dataset.productcount;
        if (numOfProducts > 0) {
            addClass(noFilterResults, HIDDEN_CLASS);
        } else {
            removeClass(noFilterResults, HIDDEN_CLASS);
        }
    }
});

baseSearch.showMore = function () {
    const productGrid = queryFirst('.product-grid');
    const pagination = queryFirst('.pagination', productGrid);
    // Show more, traditional, and new pagination link event to load new products
    $container.on('click', '.show-more button, .product-grid .pagination a', function (e) {
        e.stopPropagation();
        e.preventDefault();

        const { url } = this.dataset;

        if (!url) return;

        loadProducts(url, e, !!pagination);
    });

    if (pagination) {
        const { getNestedValue } = require('../util');

        if (hasClass(pagination, 'new-pagination')) {
            $container.on('change', '.pagination-pages', e => {
                e.stopPropagation();
                loadProducts(getNestedValue(e, 'target.selectedOptions[0].dataset.url'), e, true);
            });
        }

        window.addEventListener('popstate', e => {
            const baseUrlElem = queryFirst('.ajax-base-url');
            const baseUrlWithParams = baseUrlElem && baseUrlElem.value;
            const baseUrl = baseUrlWithParams && new URL(baseUrlWithParams);
            const baseParams = baseUrl && new URLSearchParams(baseUrl.search);
            const qsParams = getNestedValue(e, 'state.path');

            if (qsParams) {
                const newParams = new URLSearchParams(qsParams.split('?')[1]);
                newParams.forEach((value, key) => {
                    baseParams.set(key, value);
                });
            }

            const finalUrl = baseUrl.origin + baseUrl.pathname + '?' + baseParams.toString();
            loadProducts(finalUrl, e, true, true);
        });
    }
};

baseSearch.applyFilter = function () {
    /**
     * Applying refinements
     * @param {Element} e event element
     */
    function onRefinement(e) {
        const { dataset } = this;

        // Store selector opens a modal; do not treat it as a refinement/filter action.
        if (hasClass(this, 'btn-in-store-pickup')) {
            return;
        }

        if (hasClass(this, 'js-store-filter-focus-btn')) {
            return;
        }

        if (hasClass(this, 'close-filters-btn')) {
            hideRefinements();
        }

        e.preventDefault();
        e.stopPropagation();

        $.spinner().start();
        $(this).trigger('search:filter', e);

        const actionUrl = dataset.href || dataset.actionUrl;
        getResultsOnPriceFilter(this, actionUrl);
    }

    const refinementSelector = `
        .subcategory-refinement-bar li button,
        .subcategory-refinement-bar li .button,
        .search-results-container button.reset,
        .filter-value button.clear-filters-btn,
        .filter-value .button.clear-filters-btn,
        .swatch-filter button,
        .swatch-filter .button,
        .refinements li button,
        .refinements li .button,
        .store-filter-container li button,
        .store-filter-container li .button
    `;

    // Mouse / touch
    $container.on('click', refinementSelector, onRefinement);

    // Store pick up: visible control is a button with role="checkbox" + hidden input; works in sidebar and inline bar
    $container.on('click', '.js-store-filter-focus-btn', function (e) {
        e.preventDefault();
        e.stopPropagation();
        toggleStoreFilterFromFocusBtn(this);
    });

    // Store pick up: native Enter/Space on role="checkbox" buttons is unreliable — drive the checkbox explicitly
    $container.on('keydown', '.js-store-filter-focus-btn', function (e) {
        if (e.key !== EVENT_KEY_ENTER && e.key !== EVENT_KEY_SPACE && e.key !== 'NumpadEnter') {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        toggleStoreFilterFromFocusBtn(this);
    });

    // Keyboard support for non-native controls (.button on div/span etc.)
    $container.on('keydown', refinementSelector, function (e) {
        const { key } = e;

        // Only emulate for non-native elements; native <button> and <a> already work.
        if (this.tagName === 'BUTTON' || this.tagName === 'A') return;

        if (key === EVENT_KEY_ENTER || key === EVENT_KEY_SPACE) {
            // prevent page scroll on Space
            e.preventDefault();
            e.stopPropagation();

            onRefinement.call(this, e);
        }
    });

    // Prevent checkbox/toggle change is store id attribute is not present
    $container.on('click', '.store-filter-toggle', event => {
        if (!event.target.dataset.storeId) {
            event.preventDefault();
        }
    });

    // Toggle checkbox change event
    $container.on('change', '.store-filter-toggle', event => {
        syncAllStorePickupFilterToggles(event.target);
        applyStoreFilter(event.target);
    });

    // Selecting a store from the drawer
    $searchResultsContainer.on('filter:updateStoreId', (_e, data) => {
        const { storeId, storeName, storeCity, storeStateCode } = data;

        if (storeId) {
            const buttonLabel = `${storeName || ''} - ${storeCity || ''}, ${storeStateCode}`;

            queryAll('.store-filter-toggle').forEach(storeFilterToggleEl => {
                storeFilterToggleEl.dataset.storeId = storeId;
                storeFilterToggleEl.dataset.storeName = storeName;
                storeFilterToggleEl.checked = true;
            });

            window.lillyUtils.shippingPreferencesConfig.storeId = storeId;
            updateStorePickupSelectorButtons(storeName, buttonLabel);

            const storeFilterToggleEl = queryAll('.store-filter-toggle').find(toggle => toggle.checked)
                || queryFirst('.store-filter-toggle');
            applyStoreFilter(storeFilterToggleEl);
            syncAllStorePickupFilterToggles(storeFilterToggleEl);
        }
    });
};

/**
 * Update query params and triger search for price refinement
 * @param {Object} e Event causing this update
 * @return {undefined} undefined if it is not submit event
 */
function refineByPrice(e) {
    const refinementPrice = queryFirst('.refinement-price');
    const minPrice = queryFirst('.price-filter-min', refinementPrice).value;
    const maxPrice = queryFirst('.price-filter-max', refinementPrice).value;
    const priceForm = queryFirst('.price-filter-form', refinementPrice);
    const applyButton = queryFirst('.price-apply-button', refinementPrice);
    const uri = priceForm.dataset.href;
    e.preventDefault();
    e.stopPropagation();

    const errorMsg = queryFirst('.js-price-filter-error-msg', refinementPrice);
    if (minPrice && maxPrice && parseInt(minPrice, 10) < parseInt(maxPrice, 10)) {
        addClass(errorMsg, HIDDEN_CLASS);
        applyButton.disabled = false;

        if (e.type !== 'submit') return;
        $.spinner().start();
        const searchParams = new URLSearchParams(uri);
        searchParams.set('pmin', parseInt(minPrice, 10));
        searchParams.set('pmax', parseInt(maxPrice, 10));
        const newUrl = decodeURIComponent(searchParams.toString());

        priceForm.dataset.href = newUrl;
        $(this).trigger('search:filter', e);
        getResultsOnPriceFilter(priceForm, newUrl);
    } else if (minPrice && maxPrice) {
        removeClass(errorMsg, HIDDEN_CLASS);
        applyButton.disabled = true;
    }
}

baseSearch.updatePrice = function () {
    $container.on('click', '.refinement-price .values button', () => {
        addClass(queryFirst('.values button', queryFirst('.refinement-price')), 'is-not-custom');
    });
    $container.on('focus', '.refinement-price input', () => {
        removeClass(queryFirst('.price-filter', queryFirst('.refinement-price')), 'is-not-custom');
    });

    // prevent negative value
    $container.on('keydown', '.refinement-price .price-filter-min, .refinement-price .price-filter-max', e => {
        if (!((e.keyCode > 95 && e.keyCode < 106) || (e.keyCode > 47 && e.keyCode < 58) || e.keyCode == 8 || e.keyCode == 9 || e.keyCode == 38 || e.keyCode == 40 || e.keyCode == 13)) {
            return false;
        }
    });

    $container.on('submit', '.price-filter-form', refineByPrice);
    $container.on('keyup', '.refinement-price .price-filter-min, .refinement-price .price-filter-max', refineByPrice);
};

/**
 * Show the filter refinements UI
 */
function showRefinements() {
    $filtersBarContainer.removeClass(hideClass);
    $modalBG.show();
    $body.addClass('filters-open');
    syncCollapsedFiltersA11y();
    $(hideBtnMobile).trigger('toggle.lp.filters', 'filter menu: show');
    $refinementBar.siblings().attr('aria-hidden', true);
    $refinementBar.closest('.row').siblings().attr('aria-hidden', true);
    $refinementBar.closest('.tab-pane.active').siblings().attr('aria-hidden', true);
    $refinementBar.closest('.container.search-results').siblings().attr('aria-hidden', true);
    $refinementBar.find('.close').trigger('focus');
}

/**
 * Hide the filter refinements UI
 */
function hideRefinements() {
    $filtersBarContainer.addClass(hideClass);
    $modalBG.hide();
    $body.removeClass('filters-open');
    syncCollapsedFiltersA11y();
    $(hideBtnMobile).trigger('toggle.lp.filters', 'filter menu: hide');
    $refinementBar.siblings().attr('aria-hidden', false);
    $refinementBar.closest('.row').siblings().attr('aria-hidden', false);
    $refinementBar.closest('.tab-pane.active').siblings().attr('aria-hidden', false);
    $refinementBar.closest('.container.search-results').siblings().attr('aria-hidden', false);
}

baseSearch.filter = function () {
    // Display refinements bar when Menu icon clicked
    $container.on('click', 'button.filter-results', function () {
        showRefinements();
    });
};

baseSearch.closeRefinements = function () {
    // Close button: close refinements and backdrop
    $container.on('click', '.refinement-bar button.close, .refinement-bar button.close-filters-btn', function (e) {
        if (e.target !== this) return;
        hideRefinements();
        const filterResults = queryFirst('.filter-results');
        if (filterResults) filterResults.focus();
    });

    document.addEventListener('click', function (e) {
        const backdrop = e.target.closest('.modal-background');
        if (!backdrop || (e.target !== backdrop)) return;

        hideRefinements();
        const filterResults = queryFirst('.filter-results');
        if (filterResults) filterResults.focus();
    }, true);

    document.addEventListener('keydown', function (e) {
        if (e.key !== EVENT_KEY_ESC) return;

        // While any Bootstrap modal is open, let modal.js / Bootstrap handle ESC first.
        // Otherwise this capture handler runs before them and collapses the PLP filter layer
        // (breaking focus return to e.g. .btn-in-store-pickup for #select-a-store-modal).
        if (queryFirst('.modal.show')) {
            return;
        }

        // Only close if the panel is actually open; bail out otherwise so we don't
        if (hasClass($filtersBarContainer[0], hideClass)) {
            return;
        }

        hideRefinements();

        // Return focus to the element that opened the panel:
        const focusTarget = matchesBreakpoint('lg')
            ? queryFirst('.hide-filter-btn')
            : queryFirst('.hide-mobile-filter-btn');
        if (focusTarget) focusTarget.focus();
    }, true);
};

baseSearch.resize = function () {
    // Close refinement bar and hide modal background if user resizes browser
    $window.on('resize', () => {
        if (window.matchMedia('(min-width: 768px)').matches) {
            $body.removeClass('modal-open');
            $modalBG.hide();
        } else {
            hideRefinements();
        }
    });
};

baseSearch.backToTop = function () {
    const backToTopButton = queryFirst('.back-to-top-icon');
    if (backToTopButton) {
        window.addEventListener('scroll', () => {
            if (document.body.scrollTop > 2200 || document.documentElement.scrollTop > 2200) {
                backToTopButton.style.display = 'block';
            } else {
                backToTopButton.style.display = 'none';
            }
        });

        backToTopButton.addEventListener('click', () => {
            scrollTo(0, 600, function () {
                return;
            });
        });
    }
};

baseSearch.sortHandler = function () {
    const selectedOption = queryFirst('.js-selected-sort-option');

    $body.on('search:sortOptions', function (e, data) {
        const { response } = data;
        const fragment = renderFragment(response);

        updateUrlQueryParam(fragment);
        parseResults(fragment);
        const sortText = updateSortOptions(fragment);
        selectedOption.innerText = sortText;
        showNoResultsText(fragment);
        updateCount(fragment);
        updateFilterCount(fragment);
        updatePatternImageSwatch(fragment);

        $body.trigger('search:updateProducts', { sortText: sortText.toLowerCase() });
    });
};

baseSearch.shopTheLookHandler = function () {
    $body.on('click', '.js-highlight-shop-the-look', function () {

        const parseBody = (html) => {
            const $html = $('<div>').append($.parseHTML(html));
            const body = $html.find('.custom-set-items');
            return body;
        };
        const highlightButon = this;
        const quickViewModal = queryFirst(`#productSetModal-${this.dataset.pid}`);

        if (!quickViewModal) {
            return;
        }

        // PLP Banner Product Link nests the modal inside .product-grid (overflow / stacking).
        // Move to body so the slide-out sits above sticky header/filters and the backdrop.
        const modalHost = quickViewModal.closest('.custom-set-detail-modal') || quickViewModal;

        if (modalHost.parentNode !== document.body) {
            document.body.appendChild(modalHost);
        }

        const $modalContent = $(quickViewModal).find('.modal-content').first();
        const spinner = ($modalContent.length ? $modalContent : $(quickViewModal)).spinner();
        spinner.start();
        $.ajax({
            url: this.dataset.url,
            method: 'GET',
            success: function (response) {
                try {
                    const parsedBody = parseBody(response.renderedTemplate);
                    const modalBody = queryFirst('.modal-body', quickViewModal);

                    if (!modalBody || !parsedBody || !parsedBody.length || !parsedBody[0]) {
                        return;
                    }

                    if (modalBody.hasChildNodes()) {
                        modalBody.replaceChild(parsedBody[0], modalBody.firstChild);
                    } else {
                        modalBody.appendChild(parsedBody[0]);
                    }

                    // update window.productInfo to set up selected size correctly
                    updateProductInfoFromQuickViewInfo(response.quickviewProductInfo);

                    const shopTheLookEl = queryFirst('.js-shop-the-look', quickViewModal);
                    if (!shopTheLookEl) {
                        return;
                    }

                    // enable/disable addToCartButton
                    enableAddAllToToteButton(shopTheLookEl);

                    // select size if it is 'one-size' product AND hide 'select size' and 'edit' buttons
                    let allProductsWithOneSize = true;
                    queryAll('.js-size-selector', shopTheLookEl)?.forEach(element => {
                        const sizeElements = queryAll('.size-btn', element);
                        if (sizeElements && sizeElements.length === 1) {
                            sizeElements[0].click();
                            const jsAttr = sizeElements[0].closest('.js-attribute');
                            addClass([queryFirst('.js-select-size-btn', jsAttr), queryFirst('.js-edit-size-btn', jsAttr)], HIDDEN_CLASS);
                        } else {
                            allProductsWithOneSize = false;
                        }
                    });

                    if (allProductsWithOneSize) {
                        removeClass(queryFirst('.js-add-all-to-tote'), HIDDEN_CLASS);
                    }

                    // init events for select/edit size
                    $(shopTheLookEl).on('click', '.js-select-size-btn, .js-edit-size-btn', function (e) {
                        const { target } = e;
                        const jsAttributeEl = target.closest('.js-attribute');
                        removeClass(queryFirst('.js-size-selector', jsAttributeEl), HIDDEN_CLASS);
                        addClass([this, queryFirst('.js-selected-size-block', jsAttributeEl)], HIDDEN_CLASS);
                    });

                    // init events for checkbox
                    $(shopTheLookEl).on('click', '.js-select-size-input', function (e) {
                        const { target } = e;
                        const jsAttributeEl = target.closest('.js-attribute');
                        const productItem = target.closest('.js-set-item');
                        const jsSizeSelectorEl = queryFirst('.size-btn.selected', jsAttributeEl);

                        if (jsSizeSelectorEl) {
                            enableAddAllToToteButton(shopTheLookEl);
                        } else {
                            toggleSelectSizeInfo(productItem);
                            target.checked = false;
                        }
                    });

                    $body.trigger('search:shopTheLookUpdated', {
                        clickedElement: highlightButon
                    });
                } finally {
                    spinner.stop();
                }
            },
            error: function () {
                spinner.stop();
            }
        });
    });
    window.addEventListener('resize', throttle(() => {
        const $open = $body.find('.modal.show:has(.js-shop-the-look)');
        $open.modal('hide');
    }, 200));
};
/**
 * Show more filer options if more then 10 options available
 */
baseSearch.showMoreFilters = function () {
    queryAll(showMoreRefinementClass)?.forEach(element => {
        if (!queryFirst(`li.${HIDDEN_CLASS}`, element.parentElement)) {
            addClass(element, HIDDEN_CLASS);
        }
    });
    $body.on('click', showMoreRefinementClass, function (e) {
        e.preventDefault();
        removeClass(queryAll(`li.${HIDDEN_CLASS}`, this.parentElement), HIDDEN_CLASS);
        addClass(this, HIDDEN_CLASS);
    });
};

/**
 * Interleave category marketing slots with tiles (see productGridSlotOrder.js).
 */
baseSearch.initProductGridMarketingSlotOrder = function () {
    $body.on('search:updateProducts', () => {
        refreshProductGridMarketingSlots(queryFirst(SELECTOR_PRODUCT_GRID));
    });
    $body.on('search:sort', () => {
        clearProductGridInitialized();
    });
    window.addEventListener('resize', throttle(() => {
        refreshIfLayoutChanged();
    }, 200));
    refreshProductGridMarketingSlots(queryFirst(SELECTOR_PRODUCT_GRID));
};

baseSearch.focusTileOnBackButton = function () {
    const productGridContainer = queryFirst('.product-grid-container');
    let activeTileId = '';
    if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
    }
    /**
     * Update url
     */
    function unloadHandler() {
        if (!activeTileId) return;

        const url = new URL(window.location.href);
        url.hash = activeTileId;
        window.history.replaceState(window.location.href, '', url);
    }

    if (productGridContainer) {
        productGridContainer.addEventListener('click', (e) => {
            const productEl = e.target.closest('.product');
            if (productEl) {
                activeTileId = productEl.getAttribute('id') || '';
            }
        });
    }

    window.addEventListener('pagehide', unloadHandler);
};

/**
 * Scroll viewport to tile
 */
function scrollToTile() {
    if (!tileToScroll) return;

    // smooth will trigger unnecessary intersaction observer
    // use promises/setTimeout in observer with smooth param
    tileToScroll.scrollIntoView({ behavior: 'instant', block: 'start' });
    tileToScroll = null;
    const url = new URL(window.location.href);
    if (url.hash) {
        url.hash = '';
        window.history.replaceState(window.location.href, '', url);
    }
    $body.trigger('search:updateProducts');
}

/**
 * Update marketing slots markup
 */
function updateSlotsMarkup() {
    const elementsToMove = queryAll('.category-marketing-slot');
    const targetElement = queryFirst('.grid-footer'); // should select again as it was replaced

    [...elementsToMove].reverse().forEach(element => {
        targetElement.parentNode.insertBefore(element, targetElement);
    });
}

/**
 * Fetch all previous links
 * @param {string} url link to load products
 * @param {boolean} previous loaded to start
 */
function fetchUrls(url, previous) {
    loadProducts(url, {}, false, false, {}, previous);
}

baseSearch.loadPreviousProducts = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const url = new URL(window.location.href);
    const productTiles = document.querySelectorAll('.js-product-grid .product');
    let elementIndex = 1;
    if (url.hash) {
        tileToScroll = document.querySelector(`.js-product-grid ${url.hash}`);
        for (let i = 0; i < productTiles.length; i++) {
            if (productTiles[i] === tileToScroll) {
                elementIndex = i;
                break;
            }
        }
    }
    if (urlParams.has('start') && urlParams.get('start')) {
        let previous = false;
        let targetURL = '';
        let loadPageContainer;

        if (!url.hash) {
            tileToScroll = productTiles[0];
        }
        if (elementIndex < productTiles.length / 2) {
            loadPageContainer = queryFirst('.js-show-previous');
            previous = true;
        } else if (elementIndex >= productTiles.length / 2) {
            loadPageContainer = queryFirst('.show-more button');
        }
        targetURL = loadPageContainer?.dataset.url;

        if (targetURL) {
            preventObserver = true;
            fetchUrls(targetURL, previous);
        } else {
            scrollToTile();
        }
    } else {
        scrollToTile();
    }
};

module.exports = baseSearch;

/**
 * Adds class 'stuck' to filters bar
 */
baseSearch.filtersBarState = () => {
    let filtersBarStyles = null;
    let filtersBarTop = 0;

    function toggleFiltersBarState() {
        plpFiltersBar.forEach((el, index) => {
            if (!filtersBarStyles) {
                const filtersBarStyle = window.getComputedStyle(el);
                filtersBarTop = parseInt(filtersBarStyle.top, 10);
            }

            const currentTop = el.getBoundingClientRect().top;
            el.classList.toggle('stuck', currentTop <= filtersBarTop);
        });
    }

    window.addEventListener('scroll', throttle(toggleFiltersBarState, 50));
};

// Scroll to the selected refinement
baseSearch.filterPositionRestore = () => {
    const scrollToRefinementEl = queryFirst('.js-scroll-to-refinement');
    if (!scrollToRefinementEl || !matchesBreakpoint('lg')) return;

    // Show the refinements menu for desktop view
    $filtersBarContainer.removeClass(hideClass);
    syncCollapsedFiltersA11y();
    const filterPanel = queryFirst('.filter-sticky-panel');
    const hideBtn = queryFirst('.hide-filter-btn', filterPanel);
    if (hideBtn) {
        hideBtn.setAttribute('aria-expanded', 'true');
    }
    // Scroll to the selected refinement
    const refinementId = queryFirst('[data-scroll-to-refinement]')?.dataset.scrollToRefinement;
    if (!refinementId) return;
    const container = queryFirst('.refinement-menu');
    const child = queryFirst(`.refinement-${refinementId}`);

    const containerTop = container.getBoundingClientRect().top;
    const childTop = child.getBoundingClientRect().top;
    const filterPannelTop = filterPanel.getBoundingClientRect().top;

    const offset = childTop - (containerTop + filterPannelTop) + container.scrollTop;

    container.scrollTo({ top: offset, behavior: 'instant' });
};
